const STORAGE_PREFIX = "weddbetsMultiWorkspace:";
const RECENTES_KEY = "weddbetsMultiWorkspacesRecentes";
const LIMITE_RECENTES = 10;

function estadoInicial() {
  return {
    principalId: "",
    janelas: [],
  };
}

export function gerarMultiWorkspaceId() {
  if (window.crypto && typeof window.crypto.randomUUID === "function") {
    return window.crypto.randomUUID();
  }

  return (
    Date.now().toString(36) +
    "_" +
    Math.random().toString(36).slice(2, 10)
  );
}

export function carregarMultiWorkspace(workspaceId) {
  if (!workspaceId) {
    return estadoInicial();
  }

  try {
    const estado = JSON.parse(
      localStorage.getItem(STORAGE_PREFIX + workspaceId)
    );
    if (!estado || typeof estado !== "object") {
      return estadoInicial();
    }

    return {
      principalId:
        typeof estado.principalId === "string" ? estado.principalId : "",
      janelas: Array.isArray(estado.janelas)
        ? estado.janelas
            .filter((janela) => janela && janela.id)
            .map((janela) => ({
              id: janela.id,
              eventoId:
                typeof janela.eventoId === "string" ? janela.eventoId : "",
              mudo: janela.mudo !== false,
              editando: !janela.eventoId,
            }))
        : [],
    };
  } catch (error) {
    return estadoInicial();
  }
}

export function salvarMultiWorkspace(workspaceId, estado, metadados = {}) {
  const normalizado = {
    principalId: estado.principalId || "",
    janelas: Array.isArray(estado.janelas)
      ? estado.janelas.map((janela) => ({
          id: janela.id,
          eventoId: janela.eventoId || "",
          mudo: janela.mudo !== false,
          editando: Boolean(janela.editando),
        }))
      : [],
  };

  try {
    localStorage.setItem(
      STORAGE_PREFIX + workspaceId,
      JSON.stringify(normalizado)
    );
    registrarMultiWorkspace(workspaceId, metadados);
  } catch (error) {
    // A página continua funcionando quando o storage não está disponível.
  }

  return normalizado;
}

export function criarMultiJanela(indice) {
  return {
    id:
      Date.now().toString(36) +
      "_" +
      Math.random().toString(36).slice(2, 8),
    eventoId: "",
    mudo: true,
    editando: true,
    indice: indice || 0,
  };
}

export function multiWorkspaceStorageKey(workspaceId, janelaId) {
  return STORAGE_PREFIX + workspaceId + ":geometry:" + janelaId;
}

function recentesStorageKey(usuarioKey) {
  return usuarioKey ? RECENTES_KEY + ":" + usuarioKey : RECENTES_KEY;
}

export function listarMultiWorkspaces(usuarioKey = "") {
  try {
    const recentes = JSON.parse(
      localStorage.getItem(recentesStorageKey(usuarioKey))
    );
    return Array.isArray(recentes)
      ? recentes
          .filter((item) => item && item.id)
          .slice(0, LIMITE_RECENTES)
      : [];
  } catch (error) {
    return [];
  }
}

export function registrarMultiWorkspace(workspaceId, metadados = {}) {
  if (!workspaceId) {
    return [];
  }

  const agora = Date.now();
  const anteriores = listarMultiWorkspaces(metadados.usuarioKey).filter(
    (item) => item.id !== workspaceId
  );
  const recentes = [
    {
      id: workspaceId,
      nome: metadados.nome || "Workspace sem evento principal",
      atualizadoEm: agora,
    },
    ...anteriores,
  ].slice(0, LIMITE_RECENTES);

  try {
    localStorage.setItem(
      recentesStorageKey(metadados.usuarioKey),
      JSON.stringify(recentes)
    );
  } catch (error) {
    // A página continua funcionando quando o storage não está disponível.
  }

  return recentes;
}
